module.exports = __webpack_public_path__ + "img/lv_failure_8.2a5089fe.png";